import React from 'react'
import {Modal, Button} from 'react-bootstrap-v5'

type Props = {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  email?: string
}

const LoginPromptModal: React.FC<Props> = ({isOpen, onConfirm, onCancel, email}) => (
  <Modal show={isOpen} onHide={onCancel} centered size='sm'>
    <Modal.Header>
      <Modal.Title>Already a customer</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className='text-center text-dark' style={{fontSize: 14, marginBottom: 0}}>
        {email ? <>We found an account for <b>{email}</b>.</> : 'We found an account for this email.'}
        <br/>Log in now.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant='primary' onClick={onConfirm}>Log in</Button>
      <Button variant='secondary' onClick={onCancel}>Not now</Button>
    </Modal.Footer>
  </Modal>
)

export default LoginPromptModal
